import React from 'react';
import {Image, Platform, Text, TouchableOpacity, View} from 'react-native';
import {
   white,
   FONT_FAMILY_REGULAR,
   isNewAPI,
   listItemBG,
} from '../../utils/utils';

const DocumentItems = props => {
   return (
      <View
         style={{
            flexDirection: 'row',
            backgroundColor: listItemBG,
            borderRadius: 4,
            marginTop: 8,
            marginHorizontal: 12,
            paddingVertical: 12,
            paddingHorizontal: 16,
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            ...Platform.select({
               web: {
                  marginTop: 0,
                  marginBottom: 8,
               },
            }),
         }}>
         <Text
            style={{
               flex: 1,
               fontSize: 12,
               marginEnd: 10,
               color: '#000000',
               fontFamily: FONT_FAMILY_REGULAR,
            }}>
            {isNewAPI ? props.item.item.FileName : props.item.item.ModuleName}
         </Text>
         <View
            style={{
               height: 20,
               width: 2,
               borderRadius: 2,
               opacity: 0.1,
               backgroundColor: '#000000',
            }}
         />
         <TouchableOpacity
            onPress={() => {
               props.onRowClick();
            }}>
            <Image
               source={require('../../assets/downloadIcon-black.png')}
               style={{
                  tintColor: 'black',
                  width: 18,
                  height: 18,
                  marginLeft: 10,
               }}
            />
         </TouchableOpacity>
      </View>
   );
};

export default DocumentItems;
